var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"scale"}},[(_vm.showFlag)?_c('div',{staticClass:"toast flex-wrap"},[_c('div',{staticClass:"toastWin"},[_c('div',{staticClass:"content"},[_c('p',[_vm._v(_vm._s(_vm.text))])])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }